var els = $('[data-transactable-collaborator]');
if (els.length > 0) {
  require.ensure('../listings/collaborators', function(require) {
    var Collaborators = require('../listings/collaborators');
    return new Collaborators($(els[0]).closest('form'));
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/collaborators.initializer.js